import {API} from '../../backend';
import { objectToQueryString } from '../../lib/utils';


export const getTax=(userId,token,profileId)=>{
  return fetch(`${API}/profile/${userId}/${profileId}`,{
    method:"GET",
    headers:{
      Authorization:`Bearer ${token}`,
      Accept:"application/json"
    }
  }).then(res=>res.json()).catch(err => { console.error(err); return { error: true, message: err?.message }; })
}


export const getProfiles=(userId,token,query)=>{
  let str=objectToQueryString(query)
  return fetch(`${API}/profiles/${userId}?${str}`,{
    method:"GET",
    headers:{
      Authorization:`Bearer ${token}`,
      Accept:"application/json"
    }
  }).then(res=>res.json()).catch(err => { console.error(err); return { error: true, message: err?.message }; })
}

export const getProfileCount=(userId,token,query)=>{
  let str=objectToQueryString(query)
  return fetch(`${API}/profiles-count/${userId}?${str}`,{
    method:"GET",
    headers:{
      Authorization:`Bearer ${token}`,
      Accept:"application/json"
    }
  }).then(res=>res.json()).catch(err => { console.error(err); return { error: true, message: err?.message }; })
}

export const getProfileByBranches=(userId,token)=>{
  return fetch(`${API}/profile-by-branches/${userId}`,{
    method:"GET",
    headers:{
      Authorization:`Bearer ${token}`,
      Accept:"application/json"
    }
  }).then(res=>res.json()).catch(err => { console.error(err); return { error: true, message: err?.message }; })
}